export default class Stats {
  /*
   * Mandatory options: el, tmpl, hitCount, time
   */
  constructor(options) {
    Object.assign(this, options);
  }

  render() {
    const vars = {
      nbHits: this.hitCount.toLocaleString(),
      processingTimeMS: this.time,
      nbHits_plural: this.hitCount !== 1
    };

    this.el.html(this.tmpl.render(vars));
  }
}
